const dict = {
  "nav_group_overview": "Resumen",
  "nav_group_sales": "Ventas",
  "nav_group_customers": "Clientes",
  "nav_group_service": "Servicio y Calidad",
  "nav_group_contracts": "Contratos",
  "nav_group_operations": "Operaciones",
  "nav_group_insights": "Análisis",
  "nav_group_ki": "IA",
  "nav_group_purchasing": "Compras",
  "nav_sub_suppliers": "Proveedores",
  "nav_sub_procurement": "Aprovisionamiento",
  "nav_sub_quality": "Calidad",
  "nav_sub_analytics": "Análisis y ahorros",
  "nav_sub_governance": "Gobernanza y sistemas",
  "ki_menu": "Menú IA",
  "ki_costs": "Costes IA",
  "quote_comparison": "Comparación de ofertas IA",
  "my_access": "Mis derechos",
  "my_accounts_rights": "Mis cuentas y derechos",
  "my_role": "Rol / perfil",
  "visible_accounts": "Cuentas visibles",
  "all_accounts_visible": "Puede ver todas las cuentas",
  "active_grants": "Permisos temporales activos",
  "no_grants": "Sin permisos temporales",
  "access_scope": "Ámbito de acceso",
  "field_permissions": "Permisos de campo",
  "roles_rights": "Roles y derechos",
  "reassign": "Reasignar",
  "responsible_reps": "Comerciales responsables",
  "assignment_history": "Historial de asignación",
  "changed_by": "Modificado por",
  "effective_date": "Fecha efectiva",
  "bulk_assign": "Asignación masiva",
  "add_grant": "Añadir permiso",
  "grant_type": "Tipo",
  "deputy": "Suplencia / vacaciones",
  "exception": "Excepción",
  "valid_from": "Válido desde",
  "valid_to": "Válido hasta",
  "reason": "Motivo",
  "access_log": "Registro de acceso",
  "access_deputy": "Acceso y suplencia",
  "restricted_account": "Restringido — solo datos básicos",
  "restricted_hint": "No está asignado a esta cuenta. Los datos comerciales están ocultos.",
  "role_profile": "Perfil de rol",
  "account_visibility": "Visibilidad de cuentas",
  "vis_all": "Todas las cuentas",
  "vis_assigned": "Solo asignadas",
  "vis_team": "Asignadas + equipo",
  "unassigned_view": "Cuentas no asignadas",
  "unassigned_hidden": "Oculto",
  "unassigned_basic": "Solo datos básicos",
  "see_revenue_qty": "Ingresos / cantidad",
  "see_wallet": "Wallet Share y competencia",
  "see_visit_notes": "Notas de visita",
  "see_web_research": "Investigación externa",
  "see_ai_analysis": "Análisis de cuenta (IA)",
  "can_reassign": "Puede reasignar cuentas",
  "grants_deputy_help": "Acceso temporal a las cuentas de un colega (p. ej. suplencia por vacaciones). Caduca automáticamente.",
  "manager": "Depende de (Team Lead)",
  "key_accounts": "Key Accounts estratégicas",
  "no_access": "Sin acceso",
  "mode_replace": "Reemplazar",
  "mode_add": "Añadir a lo existente",
  "select_accounts": "Seleccionar cuentas",
  "user": "Usuario",
  "dashboard": "Panel",
  "accounts": "Clientes",
  "contacts": "Contactos",
  "leads": "Leads",
  "opportunities": "Oportunidades",
  "quotes": "Ofertas",
  "complaints": "Reclamaciones",
  "admin": "Administración",
  "admin_settings": "Configuración",
  "search_placeholder": "Buscar clientes, contactos, oportunidades…",
  "new": "Nuevo",
  "logout": "Cerrar sesión",
  "notifications": "Notificaciones",
  "mark_all_read": "Marcar todo leído",
  "no_notifications": "Sin notificaciones",
  "save": "Guardar",
  "cancel": "Cancelar",
  "delete": "Eliminar",
  "edit": "Editar",
  "create": "Crear",
  "close": "Cerrar",
  "export_csv": "Exportar CSV",
  "import_csv": "Importar CSV",
  "records": "registros",
  "actions": "Acciones",
  "name": "Nombre",
  "company": "Empresa",
  "account": "Cliente",
  "owner": "Responsable",
  "status": "Estado",
  "stage": "Fase",
  "amount": "Importe",
  "probability": "Probabilidad",
  "segment": "Segmento",
  "segments": "Segmentos",
  "add": "Añadir",
  "segments_help": "Gestione la lista de segmentos para clientes y plantas. Renombrar actualiza todos los registros asignados.",
  "segment_name": "Nombre del segmento",
  "segment_renamed": "Segmento renombrado ✓",
  "segment_deleted": "Segmento eliminado ✓",
  "type": "Tipo",
  "email": "Correo",
  "phone": "Teléfono",
  "mobile": "Móvil",
  "title_field": "Cargo",
  "department": "Departamento",
  "buying_role": "Rol en el buying center",
  "source": "Origen",
  "score": "Score",
  "severity": "Gravedad",
  "defect_category": "Categoría de defecto",
  "claimed_value": "Valor reclamado",
  "date_received": "Fecha de recepción",
  "sla": "SLA",
  "overdue": "Vencido",
  "convert": "Convertir",
  "converted": "Convertido",
  "product_type": "Tipo de producto",
  "print_technology": "Tecnología de impresión",
  "substrate": "Sustrato / material",
  "finishing": "Acabado",
  "business_type": "Tipo de negocio",
  "competitors": "Competidores",
  "close_reason": "Motivo ganado/perdido",
  "close_date": "Cierre previsto",
  "annual_volume": "Volumen anual",
  "num_skus": "Nº SKUs",
  "num_colors": "Nº colores",
  "abc_class": "Clase ABC",
  "annual_spend": "Gasto anual en etiquetas",
  "payment_terms": "Condiciones de pago",
  "incoterm": "Incoterm",
  "credit_limit": "Límite de crédito",
  "vat_id": "NIF/CIF",
  "city": "Ciudad",
  "billing_address": "Dirección de facturación",
  "customer_since": "Cliente desde",
  "certifications": "Certificaciones",
  "region": "Región",
  "parent_account": "Empresa matriz",
  "kanban": "Kanban",
  "table": "Tabla",
  "weighted_forecast": "Forecast ponderado",
  "aging_alert": "Sin actividad desde hace 14+ días",
  "total_pipeline": "Pipeline total",
  "weighted_pipeline": "Pipeline ponderado",
  "win_rate": "Win Rate",
  "avg_deal": "Tamaño medio de operación",
  "open_opps": "Oportunidades abiertas",
  "pipeline_by_stage": "Pipeline por fase",
  "forecast_by_month": "Forecast por mes",
  "forecast_by_rep": "Forecast por comercial",
  "revenue_by_segment": "Ingresos por segmento",
  "top_opportunities": "Top 10 oportunidades",
  "open_complaints": "Reclamaciones abiertas",
  "critical": "Crítico",
  "sla_compliance": "Cumplimiento de SLA",
  "avg_resolution": "Días medios de resolución",
  "pareto": "Reclamaciones por categoría (Pareto)",
  "trend_12m": "Tendencia de reclamaciones",
  "by_severity": "Abiertas por gravedad",
  "top_accounts_complaints": "Top 5 clientes por valor de reclamación",
  "revenue_ytd": "Ingresos YTD",
  "vs_py": "vs. año anterior",
  "abc_distribution": "Distribución ABC de clientes",
  "churn_risk": "Cuentas con riesgo de fuga",
  "business_split": "Nuevo negocio vs. renovación",
  "sales_dash": "Ventas",
  "quality_dash": "Calidad",
  "management_dash": "Dirección",
  "comments": "Comentarios",
  "audit_trail": "Historial de cambios",
  "add_comment": "Añadir un comentario…",
  "post": "Enviar",
  "quote_number": "Nº de oferta",
  "validity": "Válido hasta",
  "total": "Total",
  "margin": "Margen",
  "version": "Versión",
  "revise": "Nueva versión",
  "download_pdf": "Descargar PDF",
  "line_items": "Posiciones",
  "material": "Material",
  "width": "Ancho",
  "height": "Alto",
  "quantity": "Cantidad",
  "unit_price": "Precio/1000",
  "tooling": "Utillaje",
  "cost": "Coste/1000",
  "line_total": "Total de la posición",
  "add_line": "Añadir posición",
  "price_breaks": "Precios escalonados",
  "winding": "Bobinado",
  "core_size": "Mandril",
  "labels_per_roll": "Etiquetas/rollo",
  "d8_report": "Informe 8D",
  "claimed_qty": "Cantidad reclamada",
  "accepted_value": "Valor aceptado",
  "credit_note": "Nº de nota de crédito",
  "order_number": "Nº de pedido",
  "article_number": "Nº de artículo",
  "received_via": "Recibido vía",
  "costs": "Costes de reclamación",
  "cost_credit": "Nota de crédito",
  "cost_reprint": "Reimpresión",
  "cost_freight": "Transporte",
  "save_costs": "Guardar costes",
  "delete_file_confirm": "¿Eliminar este archivo?",
  "contact": "Contacto",
  "users": "Usuarios",
  "picklists": "Listas de selección",
  "role": "Rol",
  "territory": "Territorio",
  "password": "Contraseña",
  "add_user": "Crear usuario",
  "tags": "Etiquetas",
  "info": "Detalles",
  "hierarchy": "Jerarquía",
  "children_accounts": "Filiales",
  "open_opp_value": "Valor de oportunidades abiertas",
  "avg_margin": "Margen medio",
  "estimated_volume": "Volumen anual estimado",
  "product_interest": "Interés de producto",
  "possible_duplicate": "Posible duplicado encontrado",
  "login_title": "Iniciar sesión en Encasa",
  "login_sub": "CRM y SRM para fabricantes de envases",
  "recently_viewed": "Vistos recientemente",
  "no_results": "Sin resultados",
  "loading": "Cargando…",
  "empty_title": "Aún no hay nada aquí",
  "empty_cta": "Cree su primer registro para empezar",
  "all_stages": "Todas las fases",
  "all": "Todos",
  "required_close_reason": "Seleccione el motivo del cierre",
  "mark_won": "Ganada",
  "mark_lost": "Perdida",
  "quality": "Calidad",
  "engagement": "Compromiso (0-30)",
  "linkedin": "LinkedIn",
  "preferred_language": "Idioma preferido",
  "birthday": "Cumpleaños",
  "notes": "Notas",
  "shipping_addresses": "Direcciones de envío",
  "trade_fair": "Feria",
  "activities": "Actividades",
  "calendar": "Calendario",
  "list_view": "Lista",
  "due_date": "Fecha límite",
  "priority": "Prioridad",
  "subject": "Asunto",
  "date": "Fecha",
  "time": "Hora",
  "activity_type": "Tipo",
  "done": "Hecho",
  "open_status": "Abierto",
  "visit_report": "Informe de visita",
  "attendees": "Asistentes",
  "topics": "Temas",
  "agreements": "Acuerdos",
  "next_steps": "Próximos pasos",
  "description": "Descripción",
  "tradefair": "Modo feria",
  "quick_capture": "Captura rápida de leads",
  "captured_leads": "Leads capturados",
  "save_next": "Guardar y siguiente lead",
  "today": "Hoy",
  "my_only": "Solo míos",
  "all_team": "Todo el equipo",
  "mark_done": "Marcar hecho",
  "lead_saved": "Lead guardado",
  "samples": "Muestras y artes",
  "samples_tab": "Pedidos de muestra",
  "artworks": "Aprobaciones de arte",
  "sample_number": "Nº de muestra",
  "artwork_number": "Nº de arte",
  "requested_date": "Solicitado el",
  "tracking_number": "Nº de seguimiento",
  "upload_pdf": "Subir PDF",
  "view_pdf": "Ver PDF",
  "no_file": "Aún sin archivo",
  "contracts": "Contratos",
  "contract_number": "Nº de contrato",
  "start_date": "Inicio",
  "end_date": "Fin",
  "annual_value": "Valor anual",
  "price_index": "Índice de precios",
  "index_base_value": "Valor base del índice",
  "indexation_threshold": "Umbral de indexación %",
  "indexation_clause": "Cláusula de indexación",
  "days_to_expiry": "Días hasta vencimiento",
  "expiring_soon": "Vence pronto",
  "expired": "Vencido",
  "forecast": "Forecast y objetivos",
  "target": "Objetivo",
  "actual": "Real",
  "attainment": "Cumplimiento",
  "burndown": "Objetivo vs. real (acumulado)",
  "monthly_comparison": "Objetivo vs. real mensual",
  "edit_targets": "Editar objetivos",
  "all_reps": "Todos los comerciales",
  "by_territory": "Por territorio",
  "site_match": "Emparejamiento de planta",
  "suggest_site": "Sugerir planta de producción",
  "best_press": "Mejor máquina",
  "match_missing": "No cubierto",
  "plants": "Plantas y máquinas",
  "presses": "Máquinas de impresión",
  "technology": "Tecnología",
  "max_colors": "Máx. colores",
  "web_width": "Ancho de banda (mm)",
  "add_plant": "Crear planta",
  "add_press": "Añadir máquina",
  "location": "Ubicación",
  "send_email": "Enviar por correo",
  "send_8d": "Enviar informe 8D",
  "download_8d": "PDF informe 8D",
  "recipient": "Destinatario",
  "message": "Mensaje",
  "send": "Enviar",
  "email_sent_ok": "Correo enviado",
  "email_simulated": "Correo simulado (SMTP no configurado)",
  "photos": "Fotos y archivos",
  "upload_photo": "Subir archivo",
  "portal_users": "Accesos al portal",
  "add_portal_user": "Crear acceso al portal",
  "reports": "Informes",
  "report_name": "Nombre del informe",
  "run_report": "Ejecutar",
  "save_report": "Guardar informe",
  "shared": "Compartido con el equipo",
  "add_filter": "Añadir filtro",
  "field": "Campo",
  "operator": "Operador",
  "value": "Valor",
  "export_excel": "Exportar Excel",
  "my_reports": "Informes guardados",
  "columns": "Columnas",
  "locations": "Ubicaciones",
  "site_type": "Tipo de sitio",
  "country": "País",
  "map_view": "Mapa",
  "erp_number": "Nº ERP local",
  "timezone": "Zona horaria",
  "lat": "Latitud",
  "lng": "Longitud",
  "account_manager": "Gestor de cuenta",
  "network": "Red",
  "relationships": "Relaciones",
  "add_relationship": "Añadir relación",
  "relationship_type": "Tipo de relación",
  "volume_pct": "% del volumen",
  "contract_ref": "Ref. de contrato",
  "performance": "Rendimiento",
  "otif": "OTIF",
  "on_time": "A tiempo",
  "in_full": "Completo",
  "fill_rate": "Fill Rate",
  "lead_time": "Cumplimiento de plazo",
  "complaint_rate": "Reclamaciones / 1000 pedidos",
  "forecast_accuracy": "Precisión del forecast",
  "share_of_wallet": "Share of Wallet",
  "dso": "DSO (días)",
  "health_score": "Health",
  "days_late": "Días de retraso",
  "scorecard": "Scorecard de cliente",
  "export_pdf": "Exportar PDF",
  "duplicates": "Duplicados",
  "merge": "Fusionar",
  "link_as_network": "Vincular como red",
  "confidence": "Confianza",
  "pick_survivor": "Elegir registro superviviente",
  "merged_ok": "Registros fusionados",
  "user_location_matrix": "Matriz usuario-ubicación",
  "weekly_digest": "Resumen semanal",
  "send_test": "Enviar prueba a…",
  "send_now": "Enviar ahora a todos los comerciales",
  "digest_enabled": "Envío automático los lunes a las 07:00",
  "preview": "Vista previa",
  "perm_groups": "Grupos de permisos",
  "add_group": "Crear grupo",
  "module_rights": "Derechos de módulo",
  "default_right": "Derecho por defecto",
  "margins_visible": "Márgenes visibles",
  "scoped_label": "Visibilidad por ubicación",
  "orders_12m": "Pedidos (12M)",
  "no_kpi_data": "Aún no hay historial de pedidos para este cliente",
  "qbr_package": "Paquete QBR (PDF)",
  "current_indexes": "Valores de índice actuales",
  "index_deviation": "Δ Índice",
  "index_alerts": "alertas de índice activadas",
  "renew": "Renovar",
  "renew_contract": "Renovar contrato",
  "renewed_from": "Renovado de",
  "duration_months": "Duración (meses)",
  "new_start_date": "Nuevo inicio",
  "new_end_date": "Nuevo fin",
  "contract_renewed": "Contrato renovado",
  "import_indexes": "Importar índices",
  "import_index_help": "Pegue CSV o suba un archivo. Formatos: largo (date, index_name, value) o ancho (date, index-A, index-B, …). El separador y el formato de fecha se detectan automáticamente (ISO / DE / mes).",
  "paste_csv": "Pegar datos CSV",
  "upload_file": "Subir archivo",
  "or_upload": "o subir archivo",
  "target_index": "Índice destino (solo para archivos de un valor)",
  "any_column": "Autodetectar",
  "import_result": "Importado",
  "rows_skipped": "omitido",
  "index_history": "Historial de índices",
  "index_trend": "Tendencia del índice de precios",
  "no_history_yet": "Aún sin historial – edite o importe valores",
  "last_12m": "12 meses",
  "last_24m": "24 meses",
  "last_36m": "36 meses",
  "manual": "Entrada manual",
  "import": "Importar",
  "guide": "Guía",
  "guide_title": "Guía de Encasa CRM & SRM",
  "guide_subtitle": "Todo para sacar el máximo partido a su plataforma CRM y SRM — módulo a módulo.",
  "guide_intro": "Elija un módulo abajo para saber qué hace, o vuelva a reproducir la visita guiada.",
  "start_tour": "Iniciar visita",
  "restart_tour": "Repetir visita guiada",
  "tour_skip": "Omitir visita",
  "tour_next": "Siguiente",
  "tour_back": "Atrás",
  "tour_finish": "Finalizar",
  "tour_step": "Paso",
  "greeting_morning": "Buenos días",
  "greeting_afternoon": "Buenas tardes",
  "greeting_evening": "Buenas noches",
  "todays_overview": "Aquí tiene su negocio de un vistazo hoy.",
  "tour_welcome_title": "Bienvenido a Encasa CRM & SRM",
  "tour_welcome_body": "Haga una breve visita de 60 segundos por las áreas clave. Puede repetirla cuando quiera desde la página Guía.",
  "tour_nav_title": "Navegación principal",
  "tour_nav_body": "Salte entre todos los módulos — clientes, oportunidades, ofertas, reclamaciones, contratos y más.",
  "tour_search_title": "Búsqueda global",
  "tour_search_body": "Encuentre al instante clientes, contactos, oportunidades, ofertas y reclamaciones desde cualquier lugar.",
  "tour_new_title": "Cree registros rápido",
  "tour_new_body": "Use el botón Nuevo para añadir cualquier tipo de registro sin salir de la página actual.",
  "tour_notif_title": "Notificaciones",
  "tour_notif_body": "Incumplimientos de SLA, contratos que vencen y recordatorios de aprobación llegan todos aquí.",
  "tour_done_title": "¡Todo listo!",
  "tour_done_body": "Abra la página Guía cuando quiera para obtener ayuda detallada de cada módulo.",
  "guide_desc_dashboard": "Paneles de ventas, calidad y dirección con KPIs en vivo, pipeline, forecasts y riesgo de fuga.",
  "guide_desc_accounts": "Vista 360° del cliente: jerarquía, certificaciones, KPIs, relaciones de red y exportación QBR.",
  "guide_desc_locations": "Gestione plantas/ubicaciones con vista de mapa y filtro por región y tipo de sitio.",
  "guide_desc_contacts": "Contactos con vínculos multicliente y roles del buying center.",
  "guide_desc_leads": "Scoring de leads y conversión en un clic a cliente, contacto y oportunidad.",
  "guide_desc_opportunities": "Pipeline Kanban con arrastrar y soltar, forecast ponderado, alertas de antigüedad y emparejamiento de planta.",
  "guide_desc_quotes": "Ofertas por posiciones con precios escalonados, márgenes, versionado y exportación PDF.",
  "guide_desc_complaints": "Gestión de reclamaciones 8D con seguimiento de SLA, escalado y captura de costes.",
  "guide_desc_samples": "Pedidos de muestra y aprobaciones de arte con subida de PDF real y flujo de estados.",
  "guide_desc_contracts": "Contratos con cláusulas de índice de precios, flujo de renovación y gráficos de tendencia.",
  "guide_desc_activities": "Llamadas, reuniones, visitas y tareas con un calendario de equipo compartido.",
  "guide_desc_reports": "Generador de informes con filtros, informes guardados y exportación a Excel.",
  "guide_desc_forecast": "Objetivos de territorio vs. reales con KPIs de cumplimiento y gráficos burndown.",
  "guide_desc_tradefair": "Captura rápida de leads optimizada para móvil en ferias.",
  "guide_desc_admin": "Usuarios, grupos de permisos, listas, plantas, duplicados y ajustes del resumen.",
  "customer_forecast": "Forecast de cliente",
  "select_account": "Seleccionar cliente",
  "fiscal_year": "Ejercicio fiscal",
  "scope": "Nivel",
  "customer_level": "Nivel cliente (sin proyecto)",
  "all_projects": "Todos (agregado)",
  "projects": "Proyectos",
  "project": "Proyecto",
  "new_project": "Nuevo proyecto",
  "add_project": "Crear proyecto",
  "project_name": "Nombre del proyecto",
  "link_opportunity": "Vincular oportunidad (opcional)",
  "no_opp_link": "Sin oportunidad",
  "delete_project": "Eliminar proyecto",
  "project_deleted": "Proyecto eliminado",
  "project_created": "Proyecto creado",
  "metric": "Métrica",
  "revenue": "Ingresos",
  "month": "Mes",
  "fc_revenue": "Forecast ingresos",
  "actual_revenue": "Ingresos reales",
  "fc_qty": "Forecast cantidad",
  "actual_qty": "Cantidad real",
  "total_forecast": "Forecast total",
  "total_actual": "Real total",
  "deviation": "Desviación",
  "save_forecast": "Guardar",
  "forecast_saved": "Forecast guardado",
  "forecast_vs_actual": "Forecast vs. real",
  "import_excel": "Importar Excel",
  "download_template": "Plantilla",
  "import_done": "Filas importadas",
  "aggregate_readonly": "La vista agregada es de solo lectura — elija un proyecto o el nivel cliente para editar.",
  "guide_desc_customer_forecast": "Forecast mensual de cliente y proyecto vs. real (ingresos + cantidad) con Excel.",
  "autofill_actuals": "Traer reales de los pedidos",
  "autofilled": "Meses reales rellenados",
  "no_autofill": "No se encontraron nuevos reales",
  "group": "Grupo",
  "group_rollup": "Resumen del grupo",
  "members": "Miembros",
  "fillers": "Co-packers / envasadores",
  "global_cs": "Global Customer Service",
  "assign_global_cs": "Asignar responsable global de CS",
  "cs_assigned": "Responsable global de CS asignado",
  "group_complaints": "Reclamaciones del grupo",
  "total_members": "Miembros",
  "no_cs_owner": "Sin asignar",
  "open_pipeline": "Pipeline abierto",
  "top_customer_forecast": "Top clientes · Forecast vs. real",
  "portal_quotes": "Ofertas",
  "portal_artworks": "Aprobaciones de arte",
  "approve": "Aprobar",
  "reject": "Solicitar revisión",
  "decision_saved": "Decisión guardada",
  "add_note": "Nota (opcional)",
  "awaiting_decision": "Esperando su decisión",
  "no_quotes_portal": "Aún no hay ofertas disponibles.",
  "no_artworks_portal": "No hay artes por revisar.",
  "forecast_approvals": "Aprobaciones de forecast",
  "approval_status": "Aprobación",
  "submit_for_approval": "Enviar a aprobación",
  "fc_approve": "Aprobar",
  "fc_reject": "Rechazar",
  "reject_reason": "Motivo del rechazo",
  "st_draft": "Borrador",
  "st_submitted": "En aprobación",
  "st_approved": "Aprobado",
  "st_rejected": "Rechazado",
  "st_none": "No enviado",
  "no_pending_approvals": "No hay forecasts pendientes de aprobación.",
  "submitted_by": "Enviado por",
  "pending_approval_hint": "En aprobación (aún no contabilizado como comprometido)",
  "approved_fc": "Aprobado",
  "pending_fc": "En aprobación",
  "group_qbr": "QBR del grupo (PDF)",
  "submitted_ok": "Enviado a aprobación",
  "approved_ok": "Forecast aprobado",
  "rejected_ok": "Forecast rechazado",
  "guide_desc_forecast_approvals": "Revisar, aprobar o rechazar los forecasts de cliente enviados por el equipo de ventas.",
  "history": "Historial",
  "show_history": "Historial",
  "no_history": "Aún sin historial.",
  "ev_submitted": "enviado",
  "ev_approved": "aprobado",
  "ev_rejected": "rechazado",
  "send_reminders": "Enviar recordatorios ahora",
  "reminders_sent_msg": "Recordatorios enviados",
  "lp_switch_normal": "Normal",
  "lp_switch_hero": "Modo Hero",
  "lp_eyebrow": "CRM y SRM para fabricantes de envases",
  "lp_title": "Ventas y compras en una sola plataforma.",
  "lp_desc": "Clientes, pipeline, ofertas y calidad — además de gestión de proveedores, verificación bancaria de cuatro ojos y compras. Una plataforma para fabricantes de envases: etiquetas, shrink sleeves, envases flexibles y estuches plegables.",
  "lp_cta": "Iniciar sesión en Encasa",
  "lp_f1_t": "Ventas y ofertas",
  "lp_f1_d": "Siga el pipeline, genere ofertas PDF y prevea ingresos.",
  "lp_f2_t": "Compras y proveedores",
  "lp_f2_d": "Datos maestros de proveedores, control bancario de cuatro ojos y compras.",
  "lp_f3_t": "Calidad y KPIs",
  "lp_f3_d": "Reclamaciones 8D, scorecards, forecasts e informes QBR.",
  "lp_nav_signin": "Iniciar sesión",
  "lp_features_title": "Todo para ventas y compras",
  "lp_features_sub": "Una plataforma para todo el ciclo comercial — del lead a la entrega, del proveedor a la factura.",
  "lp_f4_t": "Contratos e IA",
  "lp_f4_d": "Extracción de contratos con IA, gestión de plazos y cláusulas de índice de precios.",
  "lp_f5_t": "Analytics y forecasts",
  "lp_f5_d": "Dashboards en vivo, forecasts de clientes y KPIs de gestión.",
  "lp_f6_t": "Portales y colaboración",
  "lp_f6_d": "Portales de clientes y proveedores con acceso seguro y auditado.",
  "lp_signin_card_title": "Bienvenido de nuevo",
  "lp_explore": "Descubrir funciones",
  "lp_stat1_l": "Cliente 360°",
  "lp_stat2_l": "Idiomas",
  "lp_stat3_l": "Proceso de calidad",
  "lp_stat4_l": "Gestión de proveedores",
  "hero_eyebrow": "El extraordinario escuadrón CRM",
  "hero_tagline": "Salva tu pipeline. Derrota el caos.",
  "hero_desc": "Siete héroes. Una misión: aplastar la fuga, pulverizar los SLA y rescatar cada operación al borde del abismo.",
  "hero_cta": "Únete a la Force",
  "hero_p1_t": "Potencia de pipeline",
  "hero_p1_d": "Atraviesa tu embudo de ventas a velocidad sobrehumana.",
  "hero_p2_t": "Aniquilador de reclamaciones",
  "hero_p2_d": "Neutraliza las amenazas de calidad antes de que escalen.",
  "hero_p3_t": "Visión de forecast",
  "hero_p3_d": "Anticipa el futuro de los ingresos de cada cliente.",
  "hero_meet": "Conoce al equipo",
  "visit_notes": "Notas de visita",
  "vn_record": "Grabar nota",
  "vn_recording": "Grabando…",
  "vn_stop": "Detener grabación",
  "vn_transcribing": "Transcribiendo…",
  "vn_analyzing": "Analizando con IA…",
  "vn_transcript": "Transcripción",
  "vn_edit_transcript": "Revise y edite la transcripción antes de guardar (el dictado de nombres de producto puede fallar).",
  "vn_analyze_save": "Analizar y guardar",
  "vn_ai_summarize": "Resumir con IA",
  "vn_ai_summary_title": "Resumen de IA (Asistente de informe de visita)",
  "vn_ai_apply": "Aplicar",
  "vn_language": "Idioma",
  "vn_auto": "Detección automática",
  "vn_manual_entry": "Escribir manualmente",
  "vn_upload_email": "Subir correo",
  "vn_manual_text_ph": "Escriba aquí su nota de visita…",
  "vn_source": "Origen",
  "vn_source_voice": "Voz",
  "vn_source_email": "Correo",
  "vn_source_manual": "Manual",
  "vn_risk": "Clasificación",
  "vn_risk_green": "Normal",
  "vn_risk_yellow": "Observar",
  "vn_risk_orange": "Riesgo",
  "vn_risk_red": "Escalado",
  "vn_partner": "Interlocutor y rol",
  "vn_topics": "Temas tratados",
  "vn_agreements": "Acuerdos / puntos abiertos",
  "vn_competitors": "Competidores mencionados",
  "vn_pricing": "Temas de precio / condiciones",
  "vn_next_steps": "Próximos pasos",
  "vn_triggers": "Temas desencadenantes",
  "vn_reason": "Motivo",
  "vn_override": "Corregir clasificación",
  "vn_override_reason": "Motivo de la corrección (obligatorio)",
  "vn_linked_opps": "Oportunidades vinculadas",
  "vn_suggested_tasks": "Tareas sugeridas",
  "vn_create_tasks": "Crear tareas seleccionadas",
  "vn_tasks_created": "Tareas creadas",
  "vn_assignee": "Responsable",
  "vn_no_notes": "Aún no hay notas de visita.",
  "vn_filter_all_sources": "Todos los orígenes",
  "vn_filter_all_risks": "Todas las clasificaciones",
  "vn_search_ph": "Buscar notas… (p. ej. cuándo se habló del precio)",
  "vn_from": "Desde",
  "vn_to": "Hasta",
  "vn_creator": "Creador",
  "vn_all_creators": "Todos los creadores",
  "vn_saved": "Nota guardada",
  "vn_show_transcript": "Mostrar transcripción",
  "vn_hide_transcript": "Ocultar transcripción",
  "vn_mic_error": "Micrófono no disponible. Use entrada manual o subida de correo.",
  "vn_reanalyze": "Reanalizar",
  "vn_corrected": "corregido",
  "vn_new_note": "Nueva nota",
  "vn_who": "Quién",
  "vn_what": "Qué",
  "vn_due": "Para cuándo",
  "vn_record_hint": "Pulse para dictar su nota justo después de la reunión.",
  "vn_task_subject": "Tarea",
  "vn_add_task": "Añadir tarea",
  "escalation": "Escalado",
  "escalation_help": "Quién recibe las alertas de riesgo rojo y el resumen semanal de riesgos.",
  "escalation_saved": "Destinatarios guardados",
  "sla_rules": "Reglas de SLA",
  "sla_saved": "Reglas de SLA guardadas",
  "saving": "Guardando…",
  "hours": "horas",
  "days": "días",
  "sla_help": "Configure los umbrales de nivel de servicio que activan recordatorios y escalados automáticos en el CRM.",
  "sla_complaint_ack_hours": "Confirmación de reclamación",
  "sla_complaint_ack_hours_desc": "Horas hasta que una nueva reclamación se escala a dirección si no se confirma.",
  "sla_artwork_reminder_days": "Recordatorio de aprobación de arte",
  "sla_artwork_reminder_days_desc": "Días que un arte enviado puede esperar la aprobación del cliente antes de recordar al responsable.",
  "sla_contract_renewal_days": "Ventana de renovación de contrato",
  "sla_contract_renewal_days_desc": "Días antes del vencimiento de un contrato en que empiezan los recordatorios de renovación.",
  "orgchart_tab": "Organigrama",
  "orgchart_title": "Mapa del buying center",
  "orgchart_subtitle": "Contactos ordenados por influencia en la decisión.",
  "orgchart_tier_decision": "Decisión",
  "orgchart_tier_influence": "Influencia y apoyo",
  "orgchart_tier_operational": "Operativo / acceso",
  "orgchart_tier_empty": "Sin contactos en este nivel",
  "orgchart_no_role": "Sin rol",
  "orgchart_empty": "Aún sin contactos — añada contactos para ver el mapa del buying center.",
  "orgchart_show_all": "Mostrar todos",
  "role_decision_maker": "Decision Maker",
  "role_champion": "Champion",
  "role_influencer": "Influencer",
  "role_gatekeeper": "Gatekeeper",
  "role_user": "User",
  "guide_desc_visit_notes": "Notas de visita con IA: dicte o suba correos, obtenga resúmenes estructurados y una clasificación de riesgo de 4 niveles.",
  "ai_contract_analysis": "Análisis de contrato con IA",
  "contract_summary": "Resumen",
  "contract_deviations": "Desviaciones vs. datos CRM",
  "no_deviations": "No se detectaron desviaciones.",
  "contract_value": "Valor del contrato",
  "crm_value": "Valor CRM",
  "deviation_match": "Coincide",
  "deviation_deviation": "Desviación",
  "deviation_unknown": "Desconocido",
  "severity_critical": "Crítico",
  "severity_warning": "Advertencia",
  "severity_info": "Info",
  "extracted_terms": "Datos extraídos del contrato",
  "contract_parties": "Partes",
  "contract_term": "Vigencia",
  "notice_period": "Plazo de preaviso",
  "auto_renewal": "Renovación automática",
  "pricing_conditions": "Precios y condiciones",
  "volume_minimum": "Volumen / compra mínima",
  "liability_warranty": "Responsabilidad y garantía",
  "price_index_clauses": "Cláusulas de índice de precios",
  "upload_contract_doc": "Subir contrato (PDF/DOCX)",
  "analyzing": "Analizando…",
  "analyzing_hint": "Extrayendo datos con IA — puede tardar hasta 30 segundos.",
  "only_pdf_docx": "Solo PDF o DOCX",
  "no_contract_docs": "Aún no hay documentos de contrato subidos.",
  "deviations_short": "desviaciones",
  "ok": "OK",
  "pages": "páginas",
  "paragraphs": "párrafos",
  "ref_page": "pág.",
  "ref_paragraph": "párr.",
  "months": "meses",
  "yes": "Sí",
  "no": "No",
  "extraction_done": "Extracción con IA completada",
  "extraction_failed": "La extracción con IA falló",
  "confirm_delete_doc": "¿Eliminar este documento?",
  "deleted": "Eliminado",
  "view_original": "Ver original",
  "reextract": "Reanalizar",
  "back": "Atrás",
  "contract_deadlines": "Vencimientos de contratos",
  "contract_deadlines_subtitle": "Plazos de preaviso, renovaciones y vencimiento — según los datos extraídos por IA.",
  "refresh": "Actualizar",
  "urgency": "Urgencia",
  "urgency_notice_missed": "Preaviso vencido",
  "urgency_notice_soon": "Preaviso próximo",
  "urgency_expired": "Vencido",
  "urgency_expiring_soon": "Vence pronto",
  "urgency_none": "OK",
  "notice_deadline": "Fecha de preaviso",
  "with_ai_analysis": "Con análisis de IA",
  "no_deadlines": "No hay contratos abiertos.",
  "no_notice_detected": "No se detectó plazo de preaviso",
  "upload_for_notice": "Subir contrato",
  "contract_data": "Datos del contrato",
  "documents": "Documentos",
  "account_analysis": "Análisis de cuenta",
  "ai_analysis": "Análisis de cuenta con IA",
  "wallet_share_tab": "Planta y Wallet Share",
  "last_generated": "Generado por última vez",
  "generate_now": "Generar ahora",
  "update_now": "Actualizar ahora",
  "ai_never_run": "Aún no se ha generado ningún análisis.",
  "generating": "Generando análisis…",
  "ai_trend": "Evolución de tendencia",
  "ai_sentiment": "Sentimiento en el tiempo",
  "ai_stakeholders": "Análisis de poder de stakeholders",
  "ai_wallet": "Evolución del Wallet Share",
  "ai_risks_opps": "Factores de riesgo y oportunidades",
  "ai_recommendations": "Recomendaciones",
  "ai_direction": "Dirección",
  "dir_growing": "creciente",
  "dir_stable": "estable",
  "dir_declining": "decreciente",
  "ai_notable_jumps": "Saltos destacados",
  "ai_no_data": "Aún no hay datos para esta sección.",
  "ai_role": "Rol / influencia",
  "ai_stance": "Postura hacia nosotros",
  "ai_flag": "Indicador de cambio",
  "risk_label": "Riesgo",
  "chance_label": "Oportunidad",
  "priority_short": "Prio",
  "ext_research": "Investigación externa",
  "ext_research_sub": "Fuentes públicas · sin verificar",
  "ext_update": "Actualizar investigación",
  "ext_never": "Aún sin investigación externa.",
  "ext_researching": "Investigando fuentes públicas…",
  "ext_news": "Noticias de la empresa",
  "ext_financials": "Situación financiera",
  "ext_strategy": "Dirección estratégica",
  "ext_market_comp": "Competidores de mercado del cliente",
  "ext_contact_check": "Verificación de contactos",
  "ext_no_info": "No se encontró información pública relevante.",
  "ext_unverified": "sin verificar · fuente pública",
  "ext_source": "Fuente",
  "ext_no_date": "sin fecha",
  "internal_verified": "verificado · registro propio",
  "ws_plant_supply": "Suministro planta → cliente",
  "ws_add_supply": "Añadir suministro",
  "ws_plant": "Planta",
  "ws_period": "Periodo",
  "ws_period_month": "Mensual",
  "ws_period_quarter": "Trimestral",
  "ws_qty": "Cantidad",
  "ws_unit": "Unidad",
  "ws_revenue": "Ingresos (EUR)",
  "ws_wallet": "Wallet Share (nivel cliente)",
  "ws_add_wallet": "Añadir entrada de Wallet Share",
  "ws_category": "Categoría",
  "ws_budget": "Presupuesto/necesidad total (EUR)",
  "ws_our_eur": "Nuestra parte (EUR)",
  "ws_our_pct": "Nuestra parte %",
  "ws_comp_pct": "Parte de competencia %",
  "ws_total_pct": "Total %",
  "ws_competitors": "Competidores",
  "ws_comp_name": "Competidor",
  "ws_comp_share": "Parte %",
  "ws_comp_source": "Fuente",
  "ws_add_competitor": "Añadir competidor",
  "ws_over100": "La suma de las partes supera el 100% — revise, por favor.",
  "ws_stale": "Los datos de Wallet Share tienen más de 6 meses — actualícelos.",
  "ws_trend": "Wallet Share en el tiempo",
  "ws_no_supply": "Aún no hay suministros de planta registrados.",
  "ws_no_wallet": "Aún no hay entradas de Wallet Share.",
  "ws_notes": "Notas / fuente",
  "ws_change_history": "Historial de cambios",
  "ws_saved": "Guardado",
  "ws_deleted": "Eliminado",
  "plant_view": "Vista de planta",
  "plant_view_sub": "Qué clientes abastece cada planta",
  "pv_customers": "Clientes",
  "pv_total_qty": "Cantidad total",
  "pv_total_revenue": "Ingresos totales",
  "pv_no_data": "Aún no hay datos de suministro para esta planta.",
  "pv_select_plant": "Todas las plantas",
  "guide_desc_plant_view": "Vista agregada de planta: qué clientes abastece cada planta y con qué volumen.",
  "analysis_pdf": "PDF de análisis (QBR)",
  "access_denied_intel": "Solo ventas, KAM y dirección pueden ver estos datos.",
  "language": "Idioma",
  "lang_en": "Inglés",
  "lang_de": "Alemán",
  "lang_es": "Español",
  "lang_pt": "Portugués",
  "lang_it": "Italiano",
  "translate": "Traducir",
  "translating": "Traduciendo…",
  "show_original": "Ver original",
  "translated_hint": "Traducción por IA — los términos técnicos (Wallet Share, OTIF, SLA…) permanecen en inglés.",
  "faq": "FAQ",
  "faq_title": "Preguntas frecuentes",
  "faq_subtitle": "Respuestas rápidas a las preguntas más habituales sobre Encasa CRM & SRM.",
  "faq_intro": "¿No encuentra lo que busca? Repita la visita guiada o abra una guía de módulo arriba.",
  "guide_faq_card": "FAQ",
  "guide_desc_faq": "Respuestas a preguntas frecuentes sobre roles, contratos, forecasts, idiomas y funciones de IA.",
  "guide_getting_started": "Primeros pasos",
  "guide_gs_intro": "Cuatro pasos rápidos para ser productivo desde el primer día.",
  "guide_gs_1_t": "1 · Encuentre todo rápido",
  "guide_gs_1_d": "Use la barra de búsqueda global de arriba para saltar a cualquier cliente, contacto, oportunidad, oferta o reclamación.",
  "guide_gs_2_t": "2 · Trabaje sus clientes",
  "guide_gs_2_d": "Abra un cliente para la vista 360° — jerarquía, KPIs, contratos, notas de visita y análisis de IA en un solo lugar.",
  "guide_gs_3_t": "3 · Anticípese a los vencimientos",
  "guide_gs_3_d": "La campana de notificaciones y la página Vencimientos de contratos muestran incumplimientos de SLA, renovaciones y plazos de preaviso.",
  "guide_gs_4_t": "4 · Trabaje en su idioma",
  "guide_gs_4_d": "Cambie la interfaz entre ES/EN/DE/PT/IT cuando quiera mediante el selector de idioma de la barra superior.",
  "guide_more_help": "¿Necesita más ayuda?",
  "guide_open_faq": "Abrir FAQ",
  "guide_desc_my_access": "Consulte su rol, permisos de campo, cuentas visibles y suplencias activas.",
  "faq_q1": "¿Cómo funcionan los roles y permisos?",
  "faq_a1": "Cada usuario tiene un rol (admin, jefe de ventas, comercial, servicio al cliente, solo lectura) más un perfil de permisos opcional. Estos deciden qué cuentas ve, si ve datos comerciales (ingresos, márgenes, Wallet Share) y si puede editar. Consulte sus derechos en la página «Mis derechos».",
  "faq_q2": "Necesito trabajar en la cuenta de un colega. ¿Cómo obtengo acceso?",
  "faq_a2": "Un admin o jefe de ventas puede concederle un acceso temporal de suplencia (p. ej. por vacaciones) o una excepción puntual en Administración → Acceso y suplencia. Los permisos tienen fecha de inicio/fin y caducan automáticamente.",
  "faq_q3": "¿Cómo funciona el análisis de contratos con IA?",
  "faq_a3": "Abra un contrato, vaya a la pestaña Documentos y suba un PDF o DOCX. GPT-4o extrae la vigencia, el preaviso, la renovación automática, los precios y las cláusulas de índice — cada uno con referencia de página/párrafo — y señala desviaciones respecto a sus datos CRM. Nunca cambia sus datos; solo informa.",
  "faq_q4": "¿Qué significan las urgencias de vencimiento de contratos?",
  "faq_a4": "«Preaviso vencido» = ha pasado el plazo de cancelación; «Preaviso próximo» = dentro de 30 días; «Vence pronto» = termina en 90 días; «Vencido» = fecha de fin superada. Se basan en el preaviso extraído por IA, así que suba el documento del contrato para activarlas.",
  "faq_q5": "¿Cómo funcionan los forecasts y las aprobaciones?",
  "faq_a5": "Introduzca el forecast mensual vs. real por cliente y proyecto. Los comerciales envían un forecast del ejercicio a aprobación; los jefes de ventas lo aprueban o rechazan en la cola de Aprobaciones de forecast. Los forecasts aprobados cuentan como comprometidos; al editarlos vuelven a borrador para reaprobación.",
  "faq_q6": "¿Qué idiomas se admiten y cómo cambio?",
  "faq_a6": "La interfaz está disponible en español, inglés, alemán, portugués e italiano. Use el selector de idioma de la barra superior — su elección se recuerda en este dispositivo. Términos técnicos como Wallet Share, OTIF, SLA y QBR permanecen intencionadamente en inglés.",
  "faq_q7": "¿Puedo traducir una nota o resumen escrito en otro idioma?",
  "faq_a7": "Sí. Los resúmenes generados por IA (análisis de contrato, análisis de cuenta, notas de visita) muestran un enlace «Traducir» que muestra el texto en el idioma actual de la interfaz a demanda y permite volver al original.",
  "faq_q8": "¿Cómo funcionan las reclamaciones, el 8D y el seguimiento de SLA?",
  "faq_a8": "Las reclamaciones reciben un número REK automático y un SLA de confirmación. Si no se confirman a tiempo, escalan a dirección. Capture el informe 8D (D1–D8) y los costes, y envíe el PDF 8D al cliente directamente desde la reclamación por correo.",
  "faq_q9": "¿Cómo exporto datos?",
  "faq_a9": "La mayoría de las listas ofrecen exportación/importación CSV. El generador de informes exporta a Excel (XLSX). Scorecards, paquetes QBR y el análisis de cuenta se exportan a PDF desde sus respectivas pantallas.",
  "faq_q10": "¿Qué significan los niveles de riesgo de las notas de visita?",
  "faq_a10": "Tras dictar o subir una nota, la IA la clasifica como Normal (verde), Observar (amarillo), Riesgo (naranja) o Escalado (rojo). El naranja notifica al responsable de la cuenta; el rojo también alerta a los destinatarios de escalado. Puede corregir la clasificación con un motivo obligatorio.",
  "translations_tab": "Traducciones",
  "tr_help": "Sobrescriba cualquier texto de la interfaz por idioma. Un valor vacío restaura la traducción integrada. Los cambios se aplican al instante para todos los usuarios.",
  "tr_no_overrides": "Aún no hay overrides — busque una clave arriba para personalizar un texto.",
  "guide_manual": "Manual",
  "guide_search_ph": "Buscar una función…",
  "guide_update_btn": "Actualizar manual",
  "guide_updating": "Actualizando…",
  "guide_last_updated": "Última actualización",
  "guide_up_to_date": "Actualizado",
  "guide_generating": "El manual se está generando — el contenido mejorará en breve.",
  "guide_sec_purpose": "¿Para qué?",
  "guide_sec_steps": "Paso a paso",
  "guide_sec_tips": "Consejos",
  "guide_sec_roles": "Roles y permisos",
  "guide_select_prompt": "Seleccione un tema a la izquierda para leer su guía.",
  "guide_no_results": "No se encontró ninguna función.",
  "guide_ai_badge": "Generado por IA",
  "guide_all_topics": "Todos los temas",
  "guide_whats_new": "Novedades",
  "guide_new_badge": "Nuevo",
  "guide_whats_new_empty": "Aún no hay novedades."
};
export default dict;
